import { render, staticRenderFns } from "./imageForm.vue?vue&type=template&id=663b6672&"
import script from "./imageForm.vue?vue&type=script&lang=js&"
export * from "./imageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports